// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__ZyjrB","navLinks":"styles_navLinks__+iINw","navLinks__link":"styles_navLinks__link__qrFze","navLinks__link__active":"styles_navLinks__link__active__dp7Wy"};